import { Card, CardContent, Separator } from '@e2n/ui';
import { faDatabase } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { Hinweis } from './Hinweis.tsx';
import { DatenabrufListe, type DatenabrufEintrag } from './DatenabrufListe.tsx';
import { TitelFormular } from './TitelFormular.tsx';

type DatenabrufKarteProps = {
  datenabruf: DatenabrufEintrag[];
  startTitel: string;
  vergebeneTitel: string[];
  auswahlVorhanden: boolean;
  absendenText: string;
  laeuft: boolean;
  onAbsenden: (titel: string) => void;
};

export function DatenabrufKarte({
  datenabruf,
  startTitel,
  vergebeneTitel,
  auswahlVorhanden,
  absendenText,
  laeuft,
  onAbsenden,
}: DatenabrufKarteProps) {
  const { t } = useTranslation();

  if (datenabruf.length === 0) {
    return (
      <Hinweis
        className="max-w-[616px] border-0 shadow-lg"
        icon={faDatabase}
        titel={t('domain.e2nApi.karte.leer.title')}
        beschreibung={t('domain.e2nApi.karte.leer.description')}
      />
    );
  }

  return (
    <Card className="max-w-[616px] border-0 shadow-lg">
      <CardContent className="p-5">
        <h2 className="text-base font-bold text-neutrals-900">
          {t('domain.e2nApi.karte.title')}
        </h2>

        <div className="mt-4">
          <DatenabrufListe datenabruf={datenabruf} />
        </div>

        <Separator className="my-4" />

        <TitelFormular
          startTitel={startTitel}
          vergebeneTitel={vergebeneTitel}
          auswahlVorhanden={auswahlVorhanden}
          absendenText={absendenText}
          laeuft={laeuft}
          onAbsenden={onAbsenden}
        />
      </CardContent>
    </Card>
  );
}
